module.exports = __webpack_public_path__ + "img/2021_MarcoMarcia.87169602.png";